import AuthApi from '@/api/auth.js';
import IndexApi from '@/api/index.js';
/*获取权限*/
const baseInfo =async function(){
  return new Promise((resolve, reject) => {
    IndexApi.baseinfo({}, true)
        .then(res => {
          var list = res.data;
          var base = {};
          for (let i=0;i<list.length;i++){
            if(list[i].dictParentKey=='top_phone'){
              base.top_phone = list[i].dictName;
            }
            if(list[i].dictParentKey=='contact_phone'){
              base.contact_phone = list[i].dictName;
            }
            if(list[i].dictParentKey=='bottom_phone'){
              base.bottom_phone = list[i].dictName;
            }
            if(list[i].dictParentKey=='post_code'){
              base.post_code = list[i].dictName;
            }
            if(list[i].dictParentKey=='contact_address'){
              base.contact_address = list[i].dictName;
            }
            if(list[i].dictParentKey=='contact_website'){
              base.contact_website = list[i].dictName;
            }
            if(list[i].dictParentKey=='contact_email'){
              base.contact_email = list[i].dictName;
            }
            if(list[i].dictParentKey=='contact_pic'){
              base.contact_pic = list[i].dictName;
            }
          }
          resolve(base);
        })
        .catch(error => {
          reject(error);
        });
   });
}

export default baseInfo;



// WEBPACK FOOTER //
// ./src/store/modules/common/getBaseInfo.js